var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelveDashboardOrderStatusIssuesReported(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.854614,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FEF1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8076 34.047C13.6571 32.8965 14.4202 30.4811 13.8346 29.0658C13.2275 27.5986 11 26.4177 11 24.8546C11 23.2914 13.2276 22.1106 13.8346 20.6435C14.4202 19.2281 13.6571 16.8127 14.8076 15.6622C15.9581 14.5117 18.3735 15.2748 19.7889 14.6892C21.256 14.0822 22.4369 11.8546 24 11.8546C25.5632 11.8546 26.744 14.0822 28.2112 14.6892C29.6265 15.2748 32.0419 14.5117 33.1924 15.6622C34.3429 16.8127 33.5798 19.2282 34.1654 20.6435C34.7725 22.1107 37 23.2915 37 24.8547C37 26.4178 34.7724 27.5986 34.1654 29.0658C33.5798 30.4811 34.3429 32.8965 33.1924 34.047C32.0419 35.1975 29.6265 34.4344 28.2111 35.02C26.744 35.6271 25.5631 37.8546 24 37.8546C22.4368 37.8546 21.256 35.6271 19.7888 35.02C18.3735 34.4344 15.9581 35.1975 14.8076 34.047Z",
    stroke: "#747474",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.8546V25.8546",
    stroke: "#747474",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31.3546C24.5523 31.3546 25 30.9069 25 30.3546C25 29.8023 24.5523 29.3546 24 29.3546C23.4477 29.3546 23 29.8023 23 30.3546C23 30.9069 23.4477 31.3546 24 31.3546Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelveDashboardOrderStatusIssuesReported);
export default __webpack_public_path__ + "static/media/delve-dashboard-order-status-issues-reported.03630b639f72fffeb5c491b21105101f630ea4d61a7fac0799b199a264b92e55.svg";
export { ForwardRef as ReactComponent };